import React from "react";
import { Table } from 'antd';

export const AdmissionTableContent = ({
                        title,
                        columns,
                        data,
                      }:any) => {
  return (
    data.length > 0 ?
    <div className="admission__content-item">
        <h3 className="admission__subtitle">{title}</h3>

        <Table
            dataSource={data}
            columns={columns}
            className="admission__table"
            bordered={true}
            pagination={false}
            rowClassName={(record)=> (record.specialities && "blue") }
        />
    </div>
      : <div></div>
  )
}
